import {
  colorSchemeDark,
  colorSchemeLight,
  themeQuartz,
} from 'ag-grid-community';

function cssVar(name: string, fallback = ''): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
}

export function buildPurchaseGridTheme(isDarkTheme: boolean) {
  const scheme = isDarkTheme ? colorSchemeDark : colorSchemeLight;
  return themeQuartz.withPart(scheme).withParams({
    backgroundColor: cssVar('--card') || cssVar('--background'),
    foregroundColor: cssVar('--foreground'),
    chromeBackgroundColor: cssVar('--muted') || cssVar('--background'),
    headerTextColor: cssVar('--foreground'),
    cellTextColor: cssVar('--foreground'),
    borderColor: cssVar('--border'),
    accentColor: cssVar('--primary'),
  });
}
